import { render, staticRenderFns } from "./HeadSearch.vue?vue&type=template&id=0284cd98&scoped=true"
import script from "./HeadSearch.vue?vue&type=script&lang=js"
export * from "./HeadSearch.vue?vue&type=script&lang=js"
import style0 from "./HeadSearch.vue?vue&type=style&index=0&id=0284cd98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0284cd98",
  null
  
)

export default component.exports